var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNavigateCircleColor = function SvgNavigateCircleColor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
    fill: "#F2F8FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0805 7.21967C12.7876 6.92678 12.3127 6.92678 12.0198 7.21967C11.7269 7.51256 11.7269 7.98744 12.0198 8.28033L14.0393 10.2999H11.5C9.84315 10.2999 8.5 11.643 8.5 13.2999V15.9999C8.5 16.4142 8.83579 16.7499 9.25 16.7499C9.66421 16.7499 10 16.4142 10 15.9999V13.2999C10 12.4714 10.6716 11.7999 11.5 11.7999H14.0397L12.0198 13.8198C11.7269 14.1127 11.7269 14.5875 12.0198 14.8804C12.3127 15.1733 12.7876 15.1733 13.0805 14.8804L16.9108 11.0501L16.3883 10.5275C16.3831 10.5221 16.3778 10.5169 16.3725 10.5117L13.0805 7.21967Z",
    fill: "#007AFF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNavigateCircleColor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "navigate-circle-color.10f23a78e80acf522a9509c0214a4288.svg";